<template>
    <div :class="mergedClass">
        <component
            :is="currentIcon"
            v-if="currentIcon"
            class="w-full h-full transition-transform transform"
            :class="rotationClass"
            color="currentColor"
        />
        <slot></slot>
    </div>
</template>

<script setup>
import { importDynamicIcon } from "@/Helpers/utils.js";
import { twMerge } from "tailwind-merge";
import { computed, watch } from "vue";

const props = defineProps({
    icon: {
        type: [String, Object, Function],
        default: null,
    },
    color: {
        type: String,
        default: "gray-800",
    },
    class: {
        type: String,
        default: "",
    },
    rotate: {
        type: Boolean,
        default: false,
    },
    rotationAngle: {
        type: String,
        default: "-rotate-45",
    },
});

const mergedClass = computed(() =>
    twMerge(
        `text-${props.color} inline-block bg-white p-1 border-2 border-${props.color} rounded-full fill-current border-current flex items-center justify-center flex-shrink-0`,
        props.class
    )
);

const rotationClass = computed(() => {
    return [props.rotate ? props.rotationAngle : ""];
});

let currentIcon = importDynamicIcon(props);

watch(
    () => props.icon,
    () => {
        currentIcon = importDynamicIcon(props);
    }
);
</script>
